import { useState } from 'react';
import { toast } from 'react-hot-toast';

import { RenderBankLogoName } from 'components/RenderBankPaymentMethod';
import FormDirectDebitBTN from 'components/FormDirectDebit/FormDirectDebitBTN';

import { ItemPayment, SettingsProps, PaymentResultData } from 'pages/types';

interface PaymentMethodType {
  data: ItemPayment[];
  settings: SettingsProps;
  setDataPayment: (value: PaymentResultData) => void;
  setPickPayment: (value: boolean) => void;
}

const MethodDirectDebit: React.FC<PaymentMethodType> = ({
  data,
  settings,
  setDataPayment,
  setPickPayment,
}) => {
  const [accountCC, setAccountCC] = useState<string>('');
  const [paymentType, setPaymentType] = useState<ItemPayment | undefined>();
  const [pickDirectDebitBank, setPickDirectDebitBank] = useState<
    ItemPayment | undefined
  >();

  const onPickPayment = (paymentType: ItemPayment | undefined) => {
    if (!paymentType) {
      toast.error('Payment type is not selected!');
      return;
    }

    setPickDirectDebitBank(paymentType);
  };

  if (pickDirectDebitBank?.code === 'DD') {
    return (
      <div className="mt-3">
        <div
          className="border rounded-md p-3"
          style={{
            borderColor: settings.button_color,
            backgroundColor: settings.primary_color,
          }}
        >
          <FormDirectDebitBTN
            items={pickDirectDebitBank}
            active={true}
            settings={settings}
            accountCC={accountCC}
            setAccountCC={setAccountCC}
            setDataPayment={setDataPayment}
            setPickPayment={setPickPayment}
          />
        </div>
      </div>
    );
  }

  return (
    <div className="flex flex-col gap-2 py-3">
      {data.map((items) => {
        const active = paymentType?.id === items.id;
        return (
          <div className="flex flex-col gap-2" key={items.id}>
            <label
              htmlFor={items.code}
              className={`border rounded-md p-3 ${
                !active ? '!border-gray-300 !bg-white' : ''
              }`}
              style={{
                borderColor: settings.button_color,
                backgroundColor: settings.primary_color,
              }}
            >
              <div className="flex flex-row justify-between items-center">
                <RenderBankLogoName
                  title={'DD'}
                  key={items.id}
                  idx={items.id}
                  name={accountCC}
                />
                <div className="flex flex-row gap-2 items-center">
                  <input
                    id={items.code}
                    name={items.code}
                    type="checkbox"
                    aria-describedby={`${items.code}-description`}
                    className="h-4 w-4 rounded-full border-gray-300 focus:ring-primary-light"
                    checked={active}
                    onChange={() => setPaymentType(items)}
                    style={{
                      color: settings.button_color,
                    }}
                  />
                </div>
              </div>
            </label>
          </div>
        );
      })}

      <button
        style={{
          backgroundColor: settings.button_color,
          color: settings.button_text_color,
        }}
        onClick={() => onPickPayment(paymentType)}
        className={`mt-4 w-full flex flex-row items-center gap-2 justify-center rounded-md border border-transparent px-4 py-2.5 text-base font-medium text-white shadow-sm  focus:outline-none`}
      >
        CHOOSE
      </button>
    </div>
  );
};

export default MethodDirectDebit;
